import { render } from "./History.vue?vue&type=template&id=51a40a00"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=51a40a00&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__